import { useRecoilValue } from 'recoil';
import { reportTelemetryState } from '../../../storage/reports';
import { TelemetryReportTable } from './TelemetryReportTable';

type Props = {
  assetId: string;
};

export function TelemetryReportTableFromAsset({ assetId }: Props) {
  const states = useRecoilValue(reportTelemetryState(assetId));

  return <TelemetryReportTable states={states} />;
}
